import { AbstractControl, ValidatorFn } from '@angular/forms';

const invalidRPNames = [
  'auto',
  'default',
  'rv',
  'motorcycle',
  'bicycle',
  'walking',
  'light duty',
  'medium duty',
  'heavy duty',
  'temp',
  'new profile',
  'default rating',
  'van',
  'light',
  'heavy rigid',
  'midsize',
  'heavy articulated',
];

const characterRestrictionRegex = /[\^/:\\]/;
const singleWhiteSpaceRegex = /^(?!.*\s\s)\S(.*\S)?$/;
const pattern = /^(route [1-9][0-9]?[0-9]?[0-9]?)$/;

export const rpNameValidator: ValidatorFn = (nameControl: AbstractControl) => {
  const { value } = nameControl;
  if (invalidRPNames.includes(String(value).toLowerCase())) {
    return { invalidName: true };
  }

  if (characterRestrictionRegex.test(value)) {
    return { invalidCharacters: true };
  }

  if (!singleWhiteSpaceRegex.test(value)) {
    return { invalidWhiteSpaces: true };
  }
  if (pattern.test(String(value).toLowerCase())) {
    return { invalidProfileName: true };
  }
  return null;
};
